import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { FaqService } from '../../services/faq.service';
import { IFaqDto } from '../../interfaces/Faq/ifaq-dto';

@Component({
  selector: 'app-acp-portal-education',
  templateUrl: './acp-portal-education.component.html',
  styleUrls: ['./acp-portal-education.component.css']
})
export class AcpPortalEducationComponent implements OnInit {

  faq: IFaqDto;
  loading = false;

  constructor(private sharedService: SharedService, private faqService: FaqService) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadFaq();

  }

  loadFaq() {
    this.loading = true;
    this.faqService.getFaqByCode('acp-portal-education').subscribe(result => {
      this.faq = result;
      this.sharedService.showLoadingMessage = false;
      this.loading = false;
    }, error => {
      console.error(error);
      this.sharedService.showLoadingMessage = false;
      this.loading = false;
    });
  }

}
